module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_0@3x.6e760c6a.png";